import $ from 'jquery'
import axios from 'axios'
import { tfMessage } from '@/common/js/message-tf.js'
import i18n from '@/locale/i18n'
import router from '@/router'
import { HTTPServer } from '@/common/js/ajax.js'
import Vue from 'vue'
import store from '@/store'
const vueFun = new Vue()
const toolCustom = {
  appendImg(list, pictureAttachmentDomain, token, id) {
    list.map((v, k) => {
      let picColumn = v.picColumn + 1
      let picRatio = parseFloat(v.picRatio || 0) * 100
      for (let i = picColumn; i >= 1; i--) {
        let ele1 = $(id + ' tbody tr:nth-child(' + v.picRow + ') td:nth-child(' + i + ')')
        if (ele1 && ele1.length > 0) {
          ele1.css({
            position: 'relative'
          })
          let picSign = v.picSign ? 'height:60px;' : ''
          let img = ''
          if (!v.hasOwnProperty('picSign')) {
            img = `<img src="${
              pictureAttachmentDomain + v.picUrl + '&TOKEN=' + token
            }" style="${picSign}cursor:move;position:absolute;top:0;left:${picRatio}%;"/>`
          } else {
            img = `
              <div class="image__div__show" style="left:${picRatio}%;position:relative;">
                <img src="${
                  pictureAttachmentDomain + v.picUrl + '&TOKEN=' + token
                }" style="${picSign}max-height: 100%;max-width: 100%;"/>
              </div>
          `
          }
          ele1.append(img)
          return false
        }
      }
    })
  },
  // word 给图片增加事件 插入图片
  setWordImg(html) {
    let imgReg = /<img.*?(?:>|\/>)/gi
    let arr = html.match(imgReg)
    let html1 = html
    let arr1 = []
    if (arr && Array.isArray(arr) && arr.length > 0) {
      arr.map((v, k) => {
        html1 = html1.replace(v, `<placeholderImg${k}>`)
        let reg = /<img/g
        let insertImg = `<img style="max-width:100%;"`
        if (v.includes('width:81.0pt;height:45.0pt;')) {
          insertImg = `<img style="max-width:100%;width:108px;height:60px;"`
        }
        let img = v.replace(reg, insertImg)
        arr1.push(img)
      })
      arr1.map((v1, k1) => {
        let reg = `<placeholderImg${k1}>`
        html1 = html1.replace(reg, v1)
      })
    }
    return html1
  },
  getHjc(url, data) {
    if (data.ExtenNo && data.ExtenNo.includes('HJCZX')) {
      data.ExtenNo = data.ExtenNo.split('HJCZX')[1]
    }
    let baseURLCustom = 'https://kdxf.jxuntel.cn'
    if (window.hjcConfig && window.hjcConfig.requestUrl) {
      baseURLCustom = window.hjcConfig.requestUrl
    }
    let promise = new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/ivr-api/api/callcenter/' + url,
        baseURL: baseURLCustom,
        data: data
      })
        .then(res => {
          if (url === 'SubscribeEvent') {
            // var tfHead = document.getElementsByTagName('head')[0]
            // var script = document.createElement('script') // 创建一个script标签
            // script.type = 'text/javascript'
            // script.text = res.data
            // tfHead.appendChild(script)
          } else {
            if (res.data.Response === '200') {
              resolve(res.data.Data)
            } else {
              tfMessage.error(res.data.Message)
            }
          }
        })
        .catch(err => {
          reject(err)
          tfMessage.error(i18n.t('utils.networkExceptionTryAgain'))
        })
    })
    return promise
  },
  formatHjcCallevent(data) {
    if (data) {
      HTTPServer.getDataDetailMeta({ phone: data.CallerNo }).then(res => {
        res.url = decodeURI(res.url).split('/#')[1]
        this.gotoCustomListFun(res)
      })
    }
  },
  gotoCustomListFun(res) {
    let list = JSON.parse(localStorage.getItem('historyTagRecordList'))
    let oldquery = {}
    if (window.location.href.includes('frontend/module')) {
      let oldparmsArr = window.location.href.split('frontend/module?')[1].split('&')
      oldparmsArr.map(v1 => {
        let arr1 = v1.split('=')
        oldquery[arr1[0]] = arr1[1]
      })
    }
    let parmsArr = res.url.split('frontend/module?')[1].split('&')
    let parameter = {}
    parmsArr.map(v1 => {
      let arr1 = v1.split('=')
      parameter[arr1[0]] = arr1[1]
    })
    let isHaveNav = list.find(
      v => v.type === 'custom_module' && v.id === 'custom' + parameter.moduleId
    )
    if (!isHaveNav) {
      list.map(v => {
        v.active = false
      })
      let obj = {
        active: true,
        data: {
          parameter: parameter,
          path: res.url
        },
        id: 'custom' + parameter.moduleId,
        name: parameter.moduleName,
        type: 'custom_module'
      }
      list.push(obj)
    } else {
      list.map(v => {
        v.active = false
        if (v.id === 'custom' + parameter.moduleId) {
          v.active = true
        }
      })
    }
    if (location.href.includes('/frontend/')) {
      // 在前台
      if (location.href.includes('/frontend/module')) {
        HTTPServer.getSubmenuList({
          moduleId: parameter.moduleId,
          applicationId: parameter.appId
        }).then(respon => {
          router.push({ path: res.url })
          if (parameter.appId + '' === oldquery.appId + '') {
            if (oldquery.moduleId + '' === parameter.moduleId + '') {
              setTimeout(() => {
                vueFun.$bus.emit(
                  'openDataDtlNew',
                  '',
                  res.id,
                  parameter.bean,
                  parameter.moduleId,
                  parameter.moduleName,
                  3,
                  3,
                  '',
                  '',
                  '',
                  '',
                  '',
                  true
                )
              }, 1000)
              return false
            } else {
              // 自定义同一个应用下的模块切换
              vueFun.$bus.emit('historyTagRecordList', list)
              store.commit('SET_CUSTOM_APP_MODULE_DATA', {
                type: 'setToCustomMain',
                isAppChange: true
              })
            }
          } else {
            // 自定义不同应用下的模块切换
            vueFun.$bus.emit('historyTagRecordList', list)
            store.commit('SET_CUSTOM_APP_MODULE_DATA', {
              type: 'setToCustomMain',
              isAppChange: true
            })
          }
          setTimeout(() => {
            vueFun.$bus.emit(
              'diffTypesDetails',
              JSON.stringify({
                dataType: 3,
                bean_name: parameter.bean,
                id: res.id,
                bean_id: res.id,
                newAuth: 3,
                isHjcCallback: true
              })
            )
          }, 1000)
        })
      } else {
        localStorage.setItem('historyTagRecordList', JSON.stringify(list))
        router.push({ path: res.url })
        setTimeout(() => {
          vueFun.$bus.emit(
            'diffTypesDetails',
            JSON.stringify({
              dataType: 3,
              bean_name: parameter.bean,
              id: res.id,
              bean_id: res.id,
              newAuth: 3,
              isHjcCallback: true
            })
          )
        }, 1000)
      }
    } else {
      // 在后台
      localStorage.setItem('historyTagRecordList', JSON.stringify(list))
      router.push({ path: res.url })
      setTimeout(() => {
        vueFun.$bus.emit(
          'diffTypesDetails',
          JSON.stringify({
            dataType: 3,
            bean_name: parameter.bean,
            id: res.id,
            bean_id: res.id,
            newAuth: 3,
            isHjcCallback: true
          })
        )
      }, 1000)
    }
  },
  // 格式化联动数据参数
  setLinkageData(data) {
    for (let i in data) {
      if (i.includes('subform_') && Array.isArray(data[i])) {
        data[i].map(v1 => {
          for (let j in v1) {
            if (j.includes('_arr')) {
              delete v1[j]
            }
          }
        })
      }
    }
  }
}
export default toolCustom
